function r(r){return Array.isArray(r)}export{r as isArray};
//# sourceMappingURL=is-array.js.map
